<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'100px'" :search-btn-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" :tooltip-config="{ showAll: false, enterable: false }" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="24">
          <el-row :gutter="20">
            <!-- erp卡单间隔(小时) -->
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.form.ERPCard')" prop="erpOrderTime">
                <el-input-number
                  v-model="queryParams.erpOrderTime"
                  :maxlength="MAX_LENGTH.DEFAULT"
                  :placeholder="$t('inputText')"
                  class="full-width"
                  :min="0"
                  :precision="0"
                  :controls="false"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
            </el-col>
            <!-- sap卡单间隔(小时) -->
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.form.SAPCard')" prop="sapOrderTime">
                <el-input-number
                  v-model="queryParams.sapOrderTime"
                  :maxlength="MAX_LENGTH.DEFAULT"
                  :placeholder="$t('inputText')"
                  class="full-width"
                  :min="0"
                  :precision="0"
                  :controls="false"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
            </el-col>
            <!-- WMS卡单间隔(小时) -->
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.form.HJCard')" prop="hjOrderTime">
                <el-input-number
                  v-model="queryParams.hjOrderTime"
                  :maxlength="MAX_LENGTH.DEFAULT"
                  :placeholder="$t('inputText')"
                  class="full-width"
                  :min="0"
                  :precision="0"
                  :controls="false"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
            </el-col>
            <!-- 三方、内部订单号 -->
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.number')" prop="orderNo">
                <BjInput v-model="queryParams.orderNo" style="height: 1px!important;" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- 销售渠道，店铺 -->
            <BjSelectChannelStore
              :span="colSpan"
              :query-params="queryParams"
              :query-props="['channel', 'storeIdList']"
              multiple
            />
          </el-row>
        </el-col>
      </template>

      <!-- tab选择页 -->
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <el-tabs :value="queryParamsTradeStatus" type="card" @tab-click="handleTabClick">
            <el-tab-pane key="erp" :label="$t('InternalOrder.ERP')" name="erp" />
            <el-tab-pane key="sap" :label="$t('InternalOrder.SAP')" name="sap" />
            <el-tab-pane key="wms" :label="$t('InternalOrder.WMS')" name="wms" />
            <el-tab-pane key="xxx" :label="$t('InternalOrder.form.tab')" name="xxx" />
          </el-tabs>
        </el-col>
      </template>

      <!-- 导出按钮 -->
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" @click="onExport">{{ $t('exportText') }}</el-button>
        </el-col>
      </template>

      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span class="link" @click="$toBusinessThirdOrderView(scope.row.outerOrderNo, false, businessType)">{{ scope.row.webReference }}</span>
                <BjCopyIcon :copy="scope.row.webReference" />
              </template>
              <template v-else-if="col.prop === 'innerOrderNo'">
                <span class="link" @click="$toBusinessOrderInternalView(scope.row.innerOrderNo, false, businessType)">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'orderStatusStr'">
                <el-tag :type="scope.row[col.prop] === 'Proccessing' ? 'success' : 'info'">{{ scope.row[col.prop] }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'orderTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'creationDate'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'sapPushTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'sapPullTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'hjPushTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'hjLockTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'hjShipmentTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>

              <!-- 异常原因 -->
              <template v-else-if="col.prop === 'exceptionReason'">
                <span>{{ scope.row[col.prop] }}</span>
              </template>

              <template v-else-if="col.prop === 'tags'">
                <BjTagList v-if="scope.row.tags" :tag-code-array="scope.row.tags.split(',')" size="mini" circle />
              </template>

              <template v-else-if="col.prop === 'goodsQuatity'">
                <span class="link" @click="onSkuDetail(scope.row)">{{ scope.row[col.prop] }}</span>
              </template>
              <template v-else-if=" col.prop === 'totalAmount' || col.prop === 'buyerPay' || col.prop === 'costPrice'">
                {{ $number2money(scope.row[col.prop]) }}
              </template>

              <template v-else-if="col.prop === 'deliveryStatus'">
                <el-tag :type="scope.row[col.prop] === '30512' ? 'success' : 'info'">
                  {{ $t(ORDER_INTERNAL_DELIVER_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </el-tag>
              </template>

              <template v-else-if="col.prop === 'receivingStatus'">
                <el-tag :type="scope.row[col.prop] === '30522' ? 'success' : 'info'">{{
                  $t(ORDER_INTERNAL_RECEIVING_STATUS_LIST.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'stockFlag'">
                {{ $t(STATUS_YES_NUM.bjGet(scope.row[col.prop])) }}
              </template>

              <template v-else-if="col.prop === 'isGift'">
                <el-tag :type="scope.row[col.prop] ? 'success' : 'info'">{{
                  $t(STATUS_HAVE_TRUE.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'actionType'">
                {{ $t(ORDER_ACTION_TYPE_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'businessType'">
                {{ $t(ORDER_BUSINESS_TYPE_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'takingDeliveryWay'">
                {{ ORDER_TAKING_DELIVERY_TYPE_LIST.bjGet(scope.row[col.prop]) }}
              </template>
              <template v-else-if="col.prop === 'preemptionStatus'">
                {{ $t(ORDER_INTERNAL_PREEMPT_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'syncPreempStatus'">
                {{ $t(ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <!-- #endif -->
              <template v-else-if="col.prop === 'sourceStatus'">
                {{ $t(ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'suspendStatus'">
                {{ $t(ORDER_INTERNAL_HAND_UP_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'syncDeliveryStatus'">
                {{ $t(ORDER_INTERNAL_STOCK_BACK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="Object.keys(ORDER_DECRYPT_NAME).includes(col.prop)">
                <BjDecrypt :row="scope.row" :row-key="col.prop" :channel="scope.row.channel" :type="ORDER_DECRYPT_NAME[col.prop]" :order-sn="scope.row.outerOrderNo" :copy="col.prop === 'receiverPhoneMask'" />
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 弹窗 -->
    <el-dialog :title="goodsInfoTab.title" :visible.sync="goodsInfoTab.visible" width="80%">
      <GoodsInfoTab :order-id="goodsInfoTab.orderId" :business-type="businessType" />
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import GoodsInfoTab from './GoodsInfoTab';
import { downloadBlob } from '@/utils';
import {
  ORDER_TRADE_TYPE_LIST,
  ORDER_BUSINESS_TYPE_LIST,
  ORDER_ACTION_TYPE_LIST,
  STATUS_YES_NUM,
  STATUS_HAVE_TRUE,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  ORDER_INTERNAL_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_HAND_UP_STATUS_LIST,
  ORDER_TAKING_DELIVERY_TYPE_LIST,
  ORDER_BUSINESS_TYPES,
  ORDER_DECRYPT_NAME,
} from '@/utils/constants';
import axios from '@/utils/axios';
import BjDecrypt from '@/components/BjDecrypt/index.vue';
export default {
  name: 'BusinessReportOrderIndex',
  components: { GoodsInfoTab, BjDecrypt },
  mixins: [pageMiXin],
  props: {
    businessType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selection: false,
      colSpan: 8,
      ORDER_TRADE_TYPE_LIST,
      ORDER_BUSINESS_TYPE_LIST,
      ORDER_ACTION_TYPE_LIST,
      STATUS_YES_NUM,
      STATUS_HAVE_TRUE,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      ORDER_INTERNAL_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_HAND_UP_STATUS_LIST,
      ORDER_TAKING_DELIVERY_TYPE_LIST,
      ORDER_BUSINESS_TYPES,
      ORDER_DECRYPT_NAME,

      // 查询参数
      queryApi: orderApi.getStatisticsPage,
      queryParams: {
        orderStatus: null,
        businessType: this.businessType,
        // Tab页异常类型
        orderExceptionType: 0,
        orderNo: null,
        erpOrderTime: undefined,
        sapOrderTime: undefined,
        hjOrderTime: undefined,
        channel: null,
        storeIdList: [],
      },
      goodsInfoTab: {
        title: this.$t('InternalOrder.Product'),
        visible: false,
        orderId: null,
      },
      labelsVersion: 13,
      queryParamsTradeStatus: 'erp',
      // ERP超时单
      labelList1: [
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Timeout'), prop: 'timeoutDuration', isCheck: true, disabled: false, width: '182' },
        { label: this.$t('InternalOrder.form.Label'), prop: 'tags', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('InternalOrder.form.sapOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.AbnormalCause'), prop: 'exceptionReason', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Source'), prop: 'actionType', isCheck: true, disabled: false, width: '125'},
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.document'), prop: 'trackingNumber', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.placement'), prop: 'orderTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.creation'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.Pre'), prop: 'preemptionStatus', isCheck: true, disabled: false, width: '180'},
        { label: this.$t('InternalOrder.form.Sourcing'), prop: 'sourceStatus', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Pending'), prop: 'suspendStatus', isCheck: true, disabled: false, width: '180' },
      ],
      // SAP超时单
      labelList2: [
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Timeout'), prop: 'timeoutDuration', isCheck: true, disabled: false, width: '182' },
        { label: this.$t('InternalOrder.form.Label'), prop: 'tags', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('InternalOrder.form.sapOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Source'), prop: 'actionType', isCheck: true, disabled: false, width: '125'},
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.document'), prop: 'trackingNumber', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.placement'), prop: 'orderTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.creation'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.sapPullTime'), prop: 'sapPullTime', isCheck: true, disabled: false, width: '180' },
      ],
      // WMS超时单
      labelList3: [
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Timeout'), prop: 'timeoutDuration', isCheck: true, disabled: false, width: '182' },
        { label: this.$t('InternalOrder.form.Label'), prop: 'tags', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('InternalOrder.form.sapOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Source'), prop: 'actionType', isCheck: true, disabled: false, width: '125'},
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.document'), prop: 'trackingNumber', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.placement'), prop: 'orderTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.creation'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.sapPullTime'), prop: 'sapPullTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.hjPushTime'), prop: 'hjPushTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.hjLockTime'), prop: 'hjLockTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.hjShipmentTime'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '180' },
      ],
      // 有效订单
      labelList4: [
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.sapOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.Label'), prop: 'tags', isCheck: true, disabled: false, width: '130' },
        { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('InternalOrder.form.AbnormalCause'), prop: 'exceptionReason', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Source'), prop: 'actionType', isCheck: true, disabled: false, width: '125'},
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.document'), prop: 'trackingNumber', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.placement'), prop: 'orderTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.creation'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.sapPullTime'), prop: 'sapPullTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.hjPushTime'), prop: 'hjPushTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.hjLockTime'), prop: 'hjLockTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.hjShipmentTime'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Pre'), prop: 'preemptionStatus', isCheck: true, disabled: false, width: '180'},
        { label: this.$t('InternalOrder.form.Sourcing'), prop: 'sourceStatus', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.Pending'), prop: 'suspendStatus', isCheck: true, disabled: false, width: '180' },
      ],
    };
  },
  computed: {
    labelList() {
      if (this.queryParamsTradeStatus === 'erp') {
        return this.labelList1;
      } else if (this.queryParamsTradeStatus === 'sap') {
        return this.labelList2;
      } else if (this.queryParamsTradeStatus === 'wms') {
        return this.labelList3;
      } else {
        return this.labelList4;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.ROUTENAME = 'BusinessReportOrderIndex';
    });
  },
  destroyed() {
    window.ROUTENAME = null;
  },
  methods: {
    // 导出按钮 getStatisticsImport
    async onExport() {
      const Ids = [];
      const res = await orderApi.getStatisticsImport({...this.queryParams});
      if (res.children.length > 0) {
          res.children.forEach(item => Ids.push(item.id));
          axios({
              method: 'post',
              url: `/sord/v1/${this.$store.getters.tenantId}/order/order-abnormal-import?rType=2&fillerType=single-sheet&exportType=DATA&ids=${Ids.join(',')}`,
              data: this.queryParams,
              responseType: 'blob'
          }).then((res) => {
            downloadBlob(res.data, 'Order.xlsx');
            this.$refs.BjPage.onResetQuery();
          });
      }
    },

    // tab页点击方法
    handleTabClick(tab, event) {
      // 根据页面tab框向后端返回0/1/2
      this.queryParams.orderExceptionType = tab.name == 'erp' ? Number(0) : tab.name == 'sap' ? Number(1) : tab.name == 'wms' ? Number(2) : Number(3);
      window.ROUTENAME = tab.name == 'erp' ? 'BusinessReportOrderIndex' : tab.name == 'sap' ? 'BusinessReportOrderIndex2' : tab.name == 'wms' ? 'BusinessReportOrderIndex3' : 'BusinessReportOrderIndex4';
      this.reFresh();
      setTimeout(() => {
        this.queryParamsTradeStatus = tab.name;
        this.handleColumn(this.labelList);
        this.$refs.BjPage.$refs.BjTable.clearChange();
      }, 100);
    },

    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams.storeIdList = null;
      this.queryParams.orderExceptionType = 0;
      this.queryParamsTradeStatus = 'erp';
      return new Promise(resolve => {
        resolve();
      });
    },

    /** 查看商品信息 */
    onSkuDetail(row) {
      this.goodsInfoTab.orderId = row.id;
      this.goodsInfoTab.visible = true;
    },

  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
